// 为小程序环境添加navigator兼容性补丁
if (typeof navigator === 'undefined') {
  global.navigator = {
    appName: 'UniApp MiniProgram',
    userAgent: 'Mozilla/5.0 (compatible; UniApp MiniProgram)',
    platform: 'MiniProgram'
  };
} else {
  // 确保navigator对象有必要的属性
  if (typeof navigator.appName === 'undefined') {
    navigator.appName = 'UniApp MiniProgram';
  }
  if (typeof navigator.userAgent === 'undefined') {
    navigator.userAgent = 'Mozilla/5.0 (compatible; UniApp MiniProgram)';
  }
  if (typeof navigator.platform === 'undefined') {
    navigator.platform = 'MiniProgram';
  }
}

export default navigator;